var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { ref: "qrCodeHtml", staticClass: "col-md-6 col-12" }, [
        _c("div", { staticClass: "text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/thai-qr-payment.png", alt: "" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "parent" },
            [
              _vm.value
                ? _c("qrcode-vue", {
                    staticClass: "image1",
                    attrs: { value: _vm.value, size: _vm.size, level: "H" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "image2",
                attrs: {
                  src: "/static/img/thai-qr-payment-logo-sm.png",
                  width: "40",
                  alt: ""
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h3", [_vm._v("Generate QR Code")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "amount" } }, [_vm._v("Amount")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.amount,
                    expression: "amount"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "amount" },
                domProps: { value: _vm.amount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.amount = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.apiToken
              ? _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "apiToken" } }, [
                    _vm._v("Token")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.apiToken,
                        expression: "apiToken"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", id: "apiToken" },
                    domProps: { value: _vm.apiToken },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.apiToken = $event.target.value
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block btn-lg mt-4",
                on: {
                  click: function($event) {
                    return _vm.genQrCode()
                  }
                }
              },
              [_vm._v("Gen Qr Code")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                return _vm.saveScreenshot()
              }
            }
          },
          [_vm._v("Take Screenshot")]
        ),
        _vm._v(" "),
        _vm.responseData
          ? _c("div", { staticClass: "p-4" }, [
              _vm._v("\n        " + _vm._s(_vm.responseData) + "\n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card mt-4" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h3", [_vm._v("Check Generated QR Code Status")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "generatedId" } }, [
                _vm._v("Generated ID")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.origin_partner_txn_uid,
                    expression: "origin_partner_txn_uid"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "generatedId" },
                domProps: { value: _vm.origin_partner_txn_uid },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.origin_partner_txn_uid = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block btn-lg",
                  on: {
                    click: function($event) {
                      return _vm.performQrApi("inquiry")
                    }
                  }
                },
                [_vm._v("Check Qr Code")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-block btn-lg",
                  on: {
                    click: function($event) {
                      return _vm.performQrApi("void")
                    }
                  }
                },
                [_vm._v("Void")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning btn-block btn-lg",
                  on: {
                    click: function($event) {
                      return _vm.performQrApi("cancel")
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ]),
            _vm._v(" "),
            _vm.responseQrCodeStatus
              ? _c("div", { staticClass: "py-3" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.responseQrCodeStatus) +
                      "\n          "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314fe94a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314fe94a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/payment/QrCodePayment.vue
// module id = 2281
// module chunks = 0